import React, { useEffect, useRef } from 'react';

function ClimatizacionSolar({ onBackgroundImageCheck }) {
    const sectionRef = useRef(null);

    useEffect(() => {
        const sectionElement = sectionRef.current;
        const style = window.getComputedStyle(sectionElement);
        const hasBackgroundImage = style.backgroundImage !== 'none';
        onBackgroundImageCheck(hasBackgroundImage);
    }, [onBackgroundImageCheck]);

    return (
        <>
            <div id='carouselsolar' className='carousel slide w-100 carousel-fade' data-bs-ride="carousel">
                <div className='carousel-inner'>

                    {/* Primer slide */}
                    <div className='carousel-item active w-100'>
                        <div className='d-flex w-100 d-block col-12 col-md-5 position-relative' id='imgsolar' ref={sectionRef}>
                            <div className='position-absolute w-100 h-100'></div>

                            {/* Escritorio */}
                            <div className='row align-self-center w-100 d-none d-md-flex' id='alineardescripcion'>
                                <div className='col-12 col-md-7'>
                                    <h1 className='display-4 fw-bold text-white'>Climatización solar</h1>
                                    <p className='lead text-white' style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Es la forma más sostenible y eficiente de mantener la temperatura ideal en tu pileta con nuestro sistema de climatización solar.
                                        Nuestro sistema utiliza paneles solares estratégicamente ubicados para absorber el calor del sol y transferirlo al agua de tu piscina.
                                        No solo reducirás significativamente los costos de calefacción, sino que también estarás contribuyendo al cuidado del medio ambiente al utilizar energía limpia y renovable.
                                    </p>
                                </div>
                                <div className='col-md-5'></div>
                            </div>
                        </div>

                        {/* Mobile */}
                        <div className='container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h1 className='text-dark fs-2 fw-bold mb-3'>Climatización solar</h1>
                                    <p className='text-dark fs-5'>
                                        Es la forma más sostenible y eficiente de mantener la temperatura ideal en tu pileta con nuestro sistema de climatización solar.
                                        Nuestro sistema utiliza paneles solares estratégicamente ubicados para absorber el calor del sol y transferirlo al agua de tu piscina.
                                        No solo reducirás significativamente los costos de calefacción, sino que también estarás contribuyendo al cuidado del medio ambiente al utilizar energía limpia y renovable.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Segundo slide */}
                    <div className='carousel-item w-100'>
                        <div className='d-flex w-100 d-block col-12 col-md-5 position-relative' id='imgsolar2' ref={sectionRef}>
                            <div className='position-absolute w-100 h-100'></div>

                            {/* Escritorio */}
                            <div className='row align-self-center w-100 d-none d-md-flex' id='alineardescripcion'>
                                <div className='col-12 col-md-7'>
                                    <h1 className='display-4 fw-bold text-white'>Climatización solar</h1>
                                    <p className='lead text-white' style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Es la forma más sostenible y eficiente de mantener la temperatura ideal en tu pileta con nuestro sistema de climatización solar.
                                        Nuestro sistema utiliza paneles solares estratégicamente ubicados para absorber el calor del sol y transferirlo al agua de tu piscina.
                                        No solo reducirás significativamente los costos de calefacción, sino que también estarás contribuyendo al cuidado del medio ambiente al utilizar energía limpia y renovable.
                                    </p>
                                </div>
                                <div className='col-md-5'></div>
                            </div>
                        </div>

                        {/* Mobile */}
                        <div className='container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h1 className='text-dark fs-2 fw-bold mb-3'>Climatización solar</h1>
                                    <p className='text-dark fs-5'>
                                        Es la forma más sostenible y eficiente de mantener la temperatura ideal en tu pileta con nuestro sistema de climatización solar.
                                        Nuestro sistema utiliza paneles solares estratégicamente ubicados para absorber el calor del sol y transferirlo al agua de tu piscina.
                                        No solo reducirás significativamente los costos de calefacción, sino que también estarás contribuyendo al cuidado del medio ambiente al utilizar energía limpia y renovable.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Botones de navegación */}
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselsolar" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselsolar" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    );
}

export default ClimatizacionSolar;
